import React, { useEffect, useState } from "react";
import "./Certificate.scss";
import NfcNavbar from "./components/navbar.component";
import { useNavigate, useParams } from "react-router-dom";
import { getProfile } from "../../services/axiosService";

const CertificatePage = () => {
  const [item, setItem] = useState({});

  const navigate = useNavigate();
  const { itemNumber } = useParams();

  useEffect(() => {
    const getProfileAsync = async () => {
      try {
        const formattedNumber = itemNumber.startsWith("0")
          ? itemNumber.slice(1)
          : itemNumber;

        const convertedNumber = Number(formattedNumber);
        if (!convertedNumber) {
          navigate("not-found");
        } else {
          const itemProfile = await getProfile(formattedNumber);
          setItem(itemProfile.data);
        }
      } catch (err) {
        console.error("err", err);
      }
    };
    getProfileAsync();
  }, [itemNumber]);

  /* image, number and metadata item */

  const [activo, setActivo] = useState("");
  const handleSetActivo = (activo) => {
    setActivo(activo);
  };

  console.log(item);
  return (
    <div className="certificatePage">
      <div className="certificateContainer">
        <NfcNavbar itemNumber={itemNumber} />
        <div className="certificateTitlecontainer">
          <h1 className={`certificateTitle`}>CERTIFICADO</h1>
        </div>

        <div className="certificateInfo">
          <div className="certificateInfoItem">
            <p className="titleInfo">CONTRATO</p>
            <p className="getInfo">
              {item?.contractAddress
                ? `${item.contractAddress.slice(
                    0,
                    6
                  )}...${item.contractAddress.slice(-4)}`
                : ""}
            </p>
          </div>
          <div className="certificateInfoItem">
            <p className="titleInfo">TOKEN ID</p>
            <p className="getInfo">{item?.token ?? "#"}</p>
          </div>
          <div className="certificateInfoItem">
            <p className="titleInfo">BLOCKCHAIN</p>
            <p className="getInfo">Ethereum</p>
          </div>

          <p className="description">
            Cada Fancy Mona esta autentificada por un certificado digital
            registrado en la blockchain que funciona como registro de propiedad
            y originalidad.
          </p>
        </div>

        <div className={`buttonsContainer`}>
          <div className="buttonsContainerTop">
            <a
              disabled={item?.openSeaUrl === null}
              className={`buttonCertificate`}
              target="_blank"
              href={item?.openSeaUrl}
              rel="noopener noreferrer"
            >
              OpenSea
            </a>

            <a
              disabled={item?.etherscanUrl === null}
              className={`buttonCertificate`}
              href={item?.etherscanUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Etherscan
            </a>
          </div>
          <a
            className={`buttonCertificate outlined`}
            href={"https://download.com"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Obtén tu certificado
          </a>
        </div>
        <div className={`technicalCotainer`}>
          <h3 className={`technicalTitle`}>PREGUNTAS FRECUENTES</h3>
        </div>

        <div className="container mt-4 accordionSite">
          <div className="accordion" id="miAcordeon">
            <div className={`accordion-item accordionItem`} id="accordion-one">
              <div className="accordion-header">
                <h2>¿Qué es un certificado tokenizado?</h2>
                <button
                  className={`accordion-button accordionButton buttonAccordionToken ${
                    activo !== "one" ? "collapsed" : ""
                  }`}
                  onClick={() => handleSetActivo(activo === "one" ? "" : "one")}
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "one" ? "show" : ""
                }`}
              >
                <div>
                  <p>
                    Un certificado tokenizado es un documento digital que
                    asegura la autenticidad de una obra de arte de una manera
                    transparente, segura e inmutable. Este certificado digital
                    es mucho más avanzado que un certificado tradicional en
                    papel ya que que automáticamente guarda y actualiza
                    información importante sobre la obra, incluyendo:
                    <br />
                    <br />
                    El propietario actual de la obra Un historial completo de
                    todos los dueños anteriores El título oficial de la obra El
                    nombre del artista que la creó La fecha exacta de su
                    creación Lo más interesante es que toda esta información se
                    mantiene guardada de forma permanente y visible para todos,
                    lo que significa que cualquier persona puede verificar
                    fácilmente si una obra es auténtica, sin importar cuándo o
                    dónde se encuentre.
                  </p>
                </div>
              </div>
            </div>

            <div className={`accordion-item accordionItem`} id="accordion-two">
              <div className="accordion-header">
                <h2>¿Qué es una Blockchain?</h2>
                <button
                  className={`accordion-button accordionButton buttonAccordionToken ${
                    activo !== "two" ? "collapsed" : ""
                  }`}
                  onClick={() => handleSetActivo(activo === "two" ? "" : "two")}
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "two" ? "show" : ""
                }`}
              >
                <div>
                  <p>
                    Una blockchain o "cadena de bloques" es una tecnología que
                    funciona como un libro de registro digital donde se anota
                    cada transacción, pero en vez de estar en un solo lugar,
                    miles de computadoras tienen una copia exacta.
                    <br />
                    <br />
                    Cada vez que se hace una nueva transacción, se añade a un
                    "bloque" junto con otras transacciones, y estos bloques se
                    conectan entre sí formando una cadena que no se puede
                    modificar. Esta tecnología es importante porque es
                    transparente (cualquiera puede ver las transacciones),
                    segura (la información no se puede alterar) y
                    descentralizada (no depende de una única autoridad central).
                    <br />
                    <br />
                    En el contexto del arte, la blockchain permite crear
                    certificados digitales que garantizan la autenticidad de las
                    obras, mantiene un registro inmutable de la propiedad y la
                    historia de cada pieza, y facilita la verificación de la
                    autenticidad en cualquier momento y lugar.
                  </p>
                </div>
              </div>
            </div>

            <div
              className={`accordion-item accordionItem`}
              id="accordion-three"
            >
              <div className="accordion-header">
                <h2>¿Qué es OpenSea?</h2>
                <button
                  className={`accordion-button accordionButton buttonAccordionToken ${
                    activo !== "three" ? "collapsed" : ""
                  }`}
                  onClick={() =>
                    handleSetActivo(activo === "three" ? "" : "three")
                  }
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "three" ? "show" : ""
                }`}
              >
                <div>
                  <p>
                    OpenSea es el mercado digital más grande del mundo para
                    comprar y vender activos digitales únicos, similar a un
                    centro comercial virtual pero especializado en arte digital
                    y otros elementos coleccionables.
                    <br />
                    <br />
                    Lo más importante es que OpenSea proporciona un espacio
                    seguro y confiable donde artistas y coleccionistas pueden
                    conectarse directamente, eliminando la necesidad de
                    intermediarios tradicionales y asegurando que cada
                    transacción quede registrada de manera permanente en la
                    blockchain.
                  </p>
                </div>
              </div>
            </div>

            <div className={`accordion-item accordionItem`} id="accordion-four">
              <div className="accordion-header">
                <h2>¿Qué es EtherScan?</h2>
                <button
                  className={`accordion-button accordionButton buttonAccordionToken ${
                    activo !== "four" ? "collapsed" : ""
                  }`}
                  onClick={() =>
                    handleSetActivo(activo === "four" ? "" : "four")
                  }
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "four" ? "show" : ""
                }`}
              >
                <div>
                  {item?.metadata && (
                    <>
                      <p>
                        Etherscan es una herramienta web que funciona como
                        buscador que permite ver todas las transacciones que
                        ocurren en la blockchain de Ethereum. Con EthScan
                        puedes:
                        <br />
                        <br />
                        Ver el historial completo de cualquier transacción que
                        se haya realizado Verificar la autenticidad de contratos
                        inteligentes Comprobar el estado de tus transacciones en
                        tiempo real Revisar las direcciones de carteras
                        digitales y sus movimientos
                        <br />
                        <br />
                        Es como si pudieras ver el extracto bancario de todas
                        las transacciones que ocurren en la red Ethereum, pero
                        de una manera completamente pública y transparente. Esta
                        herramienta es especialmente útil cuando quieres
                        verificar la autenticidad de una obra de arte digital o
                        seguir el rastro de una transacción específica.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className={`accordion-item accordionItem`} id="accordion-four">
              <div className="accordion-header">
                <h2>¿Qué es el Token ID?</h2>
                <button
                  className={`accordion-button accordionButton buttonAccordionToken ${
                    activo !== "five" ? "collapsed" : ""
                  }`}
                  onClick={() =>
                    handleSetActivo(activo === "five" ? "" : "five")
                  }
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "five" ? "show" : ""
                }`}
              >
                <div>
                  {item?.metadata && (
                    <>
                      <p>
                        Un Token ID es un código único de identificación digital
                        que funciona como el "número de serie" de un activo
                        digital. No existen dos Token IDs iguales, lo que hace
                        que cada pieza sea única y rastreable. Este
                        identificador único es fundamental porque:
                        <br />
                        <br />
                        Garantiza la autenticidad de la obra digital Permite
                        rastrear toda la historia de propiedad y transacciones
                        de la obra Hace imposible la falsificación, ya que cada
                        Token ID está registrado en la blockchain de manera
                        permanente Cuando compras una obra de arte digital, su
                        Token ID te permite demostrar que eres el legítimo
                        propietario, de la misma manera que un número de serie
                        te ayuda a demostrar la propiedad de un objeto físico
                        valioso.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;
